import { render, staticRenderFns } from "./blofferWelfare.vue?vue&type=template&id=78950f98&scoped=true&"
import script from "./blofferWelfare.vue?vue&type=script&lang=js&"
export * from "./blofferWelfare.vue?vue&type=script&lang=js&"
import style0 from "./blofferWelfare.vue?vue&type=style&index=0&id=78950f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78950f98",
  null
  
)

export default component.exports